import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types";

export const EventOptions = t.intersection([
  t.type({
    device_id: t.string,
    session_id: t.number,
    ip: t.string,
    time: DateFromISOString,
  }),
  t.partial({
    user_id: t.string,
  }),
]);

export interface EventOptions {
  user_id?: string;
  device_id: string;
  session_id: number;
  ip: string;
  time: Date;
}
